<div *ngIf="showLoggedOut" class="alert alert-warning" role="alert"
    style="position:fixed;z-index:21;width:100%;height:40px;top:0;font-family:Montserrat;">
    <p>
        <button type="button" class="close pull-right" data-dismiss="alert" aria-label="Close" (click)="dismissAlert()"
            style="position:relative;top: -20px;">
            <span aria-hidden="true">&times;</span>
        </button>
        Please sign in again. We have detected that you are logged into the same account on a different device.
    </p>
</div>

<div [@routerTransition] style="z-index:20">
    <div class="wrapper" style="background-color:white;">
        <div class="container">
            <nav class="navbar navbar navbar-expand-md nav-white fixed-top">
                <div class="container">
                    <a class="navbar-brand" href=""><img class="header-logo" height="45"
                            src="assets/anonymouspage/images/Elek-Header.png"
                            alt="Electrotechnik Pty Ltd"></a>
                    <button class="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="cplp_navbar-right" id="navbarSupportedContent">
                        <div class="cplp_nav-phone"><img src="assets/anonymouspage/icons/phone-icon.png"
                                class="cplp_phone-icon" alt="Phone">Call Us: <a href="tel:1300093795">1300 093 795</a> |
                            <img src="assets/anonymouspage/icons/email-icon.png" class="cplp_phone-icon"
                                alt="Email">Email Us: <a href="mailto:enquiry@elek.com">enquiry&#64;elek.com</a>
                        </div>
                        <ul class="navbar-nav ml-auto navbar-right">
                            <li class="nav-item" *ngIf="!(this.appSession.userId > 0)"><a
                                    class="nav-link js-scroll-trigger" [routerLink]="['/login']">LOGIN</a></li>
                            <li class="nav-item" *ngIf="!(this.appSession.userId > 0)"><a
                                    class="nav-link js-scroll-trigger" [routerLink]="['/create-free-account']">GET FOR
                                    FREE</a></li>
                            <li class="nav-item" *ngIf="(this.appSession.userId > 0)"><a
                                    class="nav-link js-scroll-trigger"
                                    [routerLink]="['/app/main/projects']">Dashboard</a></li>
                            <!-- <li class="nav-item"><a class="nav-link js-scroll-trigger" href="javascript:void();" (click)="scrollToplans();">VIEW PLANS</a></li> -->
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
        <div id="main" class="main">
            <div class="cplp_home-2">
                <div class="container">
                    <div class="row align-center">
                        <div class="col-md-12 col-lg-5">
                            <div class="cplp_hero-content">
                                <h4>Cable Pro<sup class="cplp_sup">TM</sup> WEB</h4>
                                <h1>Cable sizing and maximum demand software</h1>
                                <!-- <p>Australia's #1 electrical software for electricians.</p> -->
                                <ul class="cplp_hero-bullets">
                                    <li>- Very easy to use</li>
                                    <li>- Accurate and compliant</li>
                                    <li>- Cloud-based</li>
                                    <li>- Use on any device</li>
                                </ul>
                                <div>
                                    <a [routerLink]="['/create-free-account']"
                                        class="btn cplp_btn-action cplp_btn-action-primary">Get For Free</a>
                                    <a href="#cplp_pricing-table"
                                        class="btn cplp_btn-action cplp_btn-action-secondary">See Pricing</a>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-12 col-lg-7">
                            <!-- <div class="cplp_hero-imagery">
                                <img class="img-fluid" src="assets/anonymouspage/images/mb.png" alt="Cable Pro Web Edition">
                                <a href="https://aws.amazon.com/what-is-cloud-computing" target="_blank"><img class="aws-logo" src="https://d0.awsstatic.com/logos/powered-by-aws-white.png" alt="Powered by AWS Cloud Computing"></a>
                            </div> -->
                            <div class="vid-cover">
                                <iframe src="https://www.youtube.com/embed/9MoTKIAtdDw?autoplay=0"
                                    allowfullscreen="allowfullscreen"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Client Section -->
            <div class="cplp_client-section">
                <div class="cplp_clients-intro text-center">
                    <h1 class="wow fadeInDown" data-wow-delay="0s">Companies using Cable Pro<sup
                            class="cplp_sup">TM</sup> Web</h1>
                </div>
                <div class="container">
                    <div class="row align-center cplp_clients">
                        <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-AGL.jpg" alt="AGL" />
                        </div>
                        <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-Laser-Electrical.jpg"
                                alt="Laser Electrical" />
                        </div>
                        <!-- <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-Nilsen.jpg" alt="Nilsen" />
                        </div> -->
                        <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-Stowe.jpg" alt="Stowe" />
                        </div>
                        <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-TafeNSW.jpg" alt="TAFE NSW" />
                        </div>


                        <div class="col-md-12 col-lg-2 cplp_single">
                            <img src="assets/anonymouspage/icons/elek-client-engie-desa.jpg" alt="Engie Desa" />
                        </div>

                    </div>
                </div>
            </div>

            <!-- Product Tour Section -->
            <div class="cplp_product-tour features">
                <div class="hero-inner">
                    <div class="container">
                        <div class="row align-center features-row-img-right">
                            <div class="col-lg-4">
                                <div class="cplp_tour-list">
                                    <ul>
                                        <li>
                                            <div class="cplp_tour-icon">
                                                <img src="assets/anonymouspage/icons/icon-studio.png" width="45"
                                                    alt="Cable Size Calculations">
                                            </div>
                                            <div class="cplp_tour-text">
                                                <h3>Cable Size Calculator</h3>
                                                <p>All cable and installation types. Cable size (auto, custom), voltage
                                                    drop (DC, 1ph, 2ph, 3ph), fault loop impedance, conduit size,
                                                    derating factors.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="cplp_tour-icon">
                                                <img src="assets/anonymouspage/icons/icon-ampere-meter.png" width="45"
                                                    alt="Maximum Demand Calculations">
                                            </div>
                                            <div class="cplp_tour-text">
                                                <h3>Maximum Demand Calculations</h3>
                                                <p>Suitable for domestic, commercial and industrial electrical projects.
                                                    Automatic or custom diversity factors.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="cplp_tour-icon">
                                                <img src="assets/anonymouspage/icons/icon-paper-report.png" width="45"
                                                    alt="Reports">
                                            </div>
                                            <div class="cplp_tour-text">
                                                <h3>Fast and Informative</h3>
                                                <p>All results are generated instantly. Detailed PDF reports are
                                                    available for all aspects.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <img class="cplp_tour-img" src="assets/anonymouspage/images/Group-CPW-1.png"
                                    alt="Cable Pro Screenshot">
                            </div>
                        </div>

                        <div class="row align-center features-row-img-left">
                            <div class="col-lg-8 features-img-left">
                                <img class="cplp_tour-img" src="assets/anonymouspage/images/Group-CPW-2.png"
                                    alt="Cable Pro Screenshot">
                            </div>
                            <div class="col-lg-4">
                                <div class="cplp_tour-list">
                                    <ul>
                                        <li>
                                            <div class="cplp_tour-icon">
                                                <img src="assets/anonymouspage/icons/icon-cloud-files.png" width="45"
                                                    alt="Cloud App">
                                            </div>
                                            <div class="cplp_tour-text">
                                                <h3>Cloud-Based Calculations for PC, Mac, iPad and Mobile.</h3>
                                                <p>Access through any browser on any device. One login keeps all your
                                                    settings. Access anywhere.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="cplp_tour-icon">
                                                <img src="assets/anonymouspage/icons/icon-notepad.png" width="45"
                                                    alt="Complies with Standards">
                                            </div>
                                            <div class="cplp_tour-text">
                                                <h3>Complies with Standards AS/NZS 3008, AS/NZS 3000, BS 7671, IEC 60364, and NFPA-70 (NEC).</h3>
                                                <p>Always perform accurate calculations in compliance with the latest
                                                    Standards.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- <div class="col-lg-8">
                                <img class="cplp_tour-img" src="assets/anonymouspage/images/elek-cableproweb-screens.png" alt="Cable Pro Screenshot">
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <!-- <a name="pricing"></a> -->
            <!-- <div id="cplp_pricing-section" class="cplp_pricing-section cplp_pricing-tables text-center"> -->
            <div id="cplp_pricing-table" class="cplp_pricing-section cplp_pricing-tables container">
                <div class="p-md-0 container-fluid">
                    <app-subscriptionplans [isFromHomePgae]="true"></app-subscriptionplans>
                    
                </div>
            </div>
            <div class="section-r">
                <div class="container">
                    <div class="row align-center">
                        <div class="col-lg-12">
                            <div class="cplp_testimonials-text-intro align-center">
                                <h1 class="wow fadeInDown" data-wow-delay="0s">What Our Users Are Saying</h1>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-10">
                            <div class="review-section">
                                <div id="reviews" class="review-section">
                                    <div class="container">
                                        <div class="row text-center">
                                            <div class="col-sm-12">
                                                <div class="reviews owl-carousel owl-theme">
                                                    <div class="review-single">
                                                        <img src="assets/anonymouspage/icons/logo-engie-med.png"
                                                            alt="Engie Desa" />
                                                        <div class="review-text wow fadeInDown" data-wow-delay="0.2s">
                                                            <p>"We have been using Cable Calc Pro for a number of years
                                                                now and always found the application and user support to
                                                                be very good. The new web based version offers all the
                                                                same functionality without the need to be installing
                                                                software on multiple user devices. Great improvement."
                                                            </p>
                                                            <h3>D. Clapton</h3>
                                                            <h4>Engie Desa</h4>
                                                        </div>
                                                    </div>
                                                    <div class="review-single">
                                                        <img src="assets/anonymouspage/icons/logo-ugl-med.png"
                                                            alt="UGL" />
                                                        <div class="review-text">
                                                            <p>"UGL purchased 4 off Cable Pro Web licenses to allow
                                                                several electrical power engineers to check their
                                                                calculations. We have found the availability of the
                                                                software excellent to perform the checks we require. The
                                                                web based version ensures our calculations are current
                                                                and based on the latest version of Cable Pro. All in all
                                                                we are more than happy with the process."</p>
                                                            <h3>B. Cheetham</h3>
                                                            <h4>UGL Limited</h4>
                                                        </div>
                                                    </div>
                                                    <div class="review-single">
                                                        <img src="assets/anonymouspage/icons/logo-goldenbay-med.png"
                                                            alt="Golden Bay Cement" />
                                                        <div class="review-text">
                                                            <p>"I tend to use Cable Pro Web from my mobile devices when
                                                                I'm out in the field. Great product."</p>
                                                            <h3>J. Vermeulen</h3>
                                                            <h4>Golden Bay Cement</h4>
                                                        </div>
                                                    </div>
                                                    <div class="review-single">
                                                        <img src="assets/anonymouspage/icons/logo-cole-med.png"
                                                            alt="Cole Contracting" />
                                                        <div class="review-text">
                                                            <p>"This product really saves me time with my cable calcs. I
                                                                use it to quantify my own calculations."</p>
                                                            <h3>T. Norval</h3>
                                                            <h4>Cole Contracting</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                </div>
            </div>

            <div id="faq" class="faq">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="faq-intro text-center">
                                <h1>Frequently Asked Questions</h1>
                                <p>A few things explained about our new cloud software</p>
                            </div>


                            <div data-accordion-group class="accordion-box">
                                <div class="accordion" data-accordion>
                                    <div data-control>
                                        <h2><i class="fa fa-arrow-down"></i>How many users can access the
                                            software?</h2>
                                    </div>
                                    <div data-content>
                                        <p>A user can access this software on one device at a time. If you are logged
                                            into the software on another device and then you log in on another device
                                            then the first device will be logged out.</p>

                                    </div>
                                </div>

                                <div class="accordion no-border" data-accordion>
                                    <div data-control>
                                        <h2><i class="fa fa-arrow-down"></i>How do I access the software?
                                        </h2>
                                    </div>
                                    <div data-content>
                                        <p>You access the software by logging in from any web browser. Simply visit <a
                                                href="https://www.cablepro.elek.com/login">https://www.cablepro.elek.com/login</a>
                                            on your device to login.</p>
                                    </div>
                                </div>
                                <div class="accordion no-border" data-accordion>
                                    <div data-control>
                                        <h2><i class="fa fa-arrow-down"></i>Can I use the software on my Mac
                                            or mobile?</h2>
                                    </div>
                                    <div data-content>
                                        <p>Yes. Cable Pro Web works on any devices.</p>
                                    </div>
                                </div>
                                <div class="accordion no-border" data-accordion>
                                    <div data-control>
                                        <h2><i class="fa fa-arrow-down"></i>Do I need internet access to
                                            access my calculations?</h2>
                                    </div>
                                    <div data-content>
                                        <p>Yes you need internet access to login to the software.</p>
                                    </div>
                                </div>
                                <div class="accordion no-border" data-accordion>
                                    <div data-control>
                                        <h2><i class="fa fa-arrow-down"></i>What if I need more projects
                                            storage?</h2>
                                    </div>
                                    <div data-content>
                                        <p>To have more project storage, upgrade to a higher tier plan or contact support to customize storage limit of your account.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cplp_footer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <!--<h2>Electrotechnik Pty Ltd</h2>-->
                            <img class="cplp_footer-logo" src="assets/anonymouspage/images/Elek-Footer.png"
                                alt="Electrotechnik Pty Ltd">
                            <p>We create beautiful electrical software which is easy to use and accurate. Visit: <a
                                    href="https://elek.com" target="_blank">elek.com</a></p>
                            <p>&copy; {{currentYear}} Electrotechnik Pty Ltd.</p>
                        </div>
                        <div class="col-md-6 text-right d-md-block">
                            <a class="cplp_f-mail" href="tel:1300093795">Call: 1300 093 795</a>
                            <br>
                            <a class="cplp_f-mail" href="mailto:support@elek.com">Email: support&#64;elek.com</a>
                            <br>
                            <div class="cplp_f-legals"><a class="cplp_f-legal" href="https://elek.com/privacy"
                                    target="_blank">Privacy Policy</a> | <a class="cplp_f-legal"
                                    href="https://elek.com/terms" target="_blank">Terms of Use</a></div>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Scroll To Top Ends-->
        </div> <!-- Main -->
        <!-- Wrapper -->

    </div>
</div>